/** Przycisk wyboru rodzaju warunku publikacji aneksu. */
export function KindButton({
  active,
  label,
  onClick,
}: {
  active: boolean
  label: string
  onClick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded border px-3 py-2 text-left ${active ? 'border-sky-500 bg-sky-50' : 'border-slate-300'}`}
    >
      <div className="font-medium text-xs uppercase">{label}</div>
    </button>
  )
}
